import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/ad-blogs/ad-blogs.css";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import SearchNButtons from "../../components/common-components/SearchNButtons";
import { selectUser } from "../../components/auth/auth.selector";
import BlogForm from "../../components/ad-blogs/blogs/BlogForm";
import { fetchBlogsData } from "../../redux/ad-blog-reducers/blogSlice";
import Blogs from "../../components/ad-blogs/blogs/Blogs";

const extractCategoryIds = (array) => {
  let blog_categories = [];

  array?.length > 0 &&
    array.forEach((item) => {
      const itemValue = item.value;
      blog_categories.push(itemValue);
    });

  return {
    blog_categories: blog_categories.join(", "),
  };
};

const AdBlogs = () => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedBlogCategories: [],
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getBlogs(filters) {
    dispatch(
      fetchBlogsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getBlogs(filters);
  }, [filters]);

  useEffect(() => {
    const { blog_categories } = extractCategoryIds(
      allFilters.selectedBlogCategories
    );

    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      status: allFilters.isActive?.value || "",
      category: blog_categories || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.isActive,
    allFilters.selectedBlogCategories,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Blogs">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          {modValues.cardName === "add" || modValues.cardName === "edit" ? (
            <BlogForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              isEdit={modValues.cardName === "edit"}
              closeModal={onCloseModal}
              callFunction={() => getBlogs(filters)}
            />
          ) : null}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Blogs"}
              createBtnTxt={"+ Add New Blog"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              isReload={() => getBlogs(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <SearchNButtons
              pageName={"blogs"}
              filters={allFilters}
              setFilters={setAllFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              userInfoData={userInfoData}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Blogs
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => getBlogs(filters)}
              userInfoData={userInfoData}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default AdBlogs;
